import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import PropertyCard from "../components/PropertyCard";
import "./StaysPage.css";

export default function StaysPage() {
  var [properties, setProperties] = useState([]);
  var [loading, setLoading] = useState(true);
  var [searchParams] = useSearchParams();
  var cityFilter = searchParams.get("city") || "";

  useEffect(function () {
    setLoading(true);
    var url = "/api/properties";
    if (cityFilter) url += "?city=" + encodeURIComponent(cityFilter);
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        setProperties(data.properties || data || []);
        setLoading(false);
      })
      .catch(function (err) {
        console.error("Failed to load properties", err);
        setLoading(false);
      });
  }, [cityFilter]);

  return (
    <div className="stays-page">
      <div className="page-hero stays-hero">
        <div className="page-hero-content">
          <div className="eyebrow" style={{ justifyContent: "center" }}>
            <div className="eline"></div>
            <span className="etxt">Our Collection</span>
          </div>
          <h1>{cityFilter ? "Stays in " + cityFilter : "All Stays"}</h1>
          <p>{cityFilter ? "Handpicked properties in " + cityFilter + ", Albania" : "Discover handpicked villas and retreats across Albania"}</p>
        </div>
      </div>
      <div className="stays-body container">
        {loading ? (
          <p className="stays-count">Loading...</p>
        ) : (
          <>
            <p className="stays-count">{properties.length} {properties.length === 1 ? "property" : "properties"} {cityFilter ? "in " + cityFilter : "available"}</p>
            <div className="properties-grid">
              {properties.map(function (prop) { return <PropertyCard key={prop._id} property={prop} />; })}
            </div>
            {properties.length === 0 && (
              <div style={{ textAlign: "center", padding: "80px 0", color: "#8a7d6e" }}>
                <p style={{ fontSize: "1.2rem", marginBottom: 12 }}>No properties found{cityFilter ? " in " + cityFilter : ""}.</p>
                <a href="/stays" style={{ color: "#c8956c" }}>View all properties →</a>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}